export const parameter = {
  TYPE: {
    NUMBER: 'number', // Can be a direct number OR a FixedSeries converted to a number
    SERIES: 'series', // An actual series to input
    NUMBER_ARRAY: 'array:number', // An array of numbers to arbitrary length
    SERIES_ARRAY: 'array:series', // An array of series of arbitrary length
  }
}